<template>
  <div class="absolute top-0 inset-x-0 max-w-1224 h-60 w-full flex items-center justify-end mx-auto">
    <nav class="mr-40">
      <ul class="flex items-center tracking-wide">
        <li>
          <RouterLink
            :to="{ name: 'PricingInformation' }"
            class="text-white uppercase mr-30"
          >
            {{ $t('home_view.price_text') }}
          </RouterLink>
        </li>
        <li>
          <a
            :href="`/app/${$i18n.locale}/sign-in`"
            class="text-white uppercase"
          >
            {{ $t('home_view.login_text') }}
          </a>
        </li>
      </ul>
    </nav>
    <UILanguageSwitcher
      switcher-classes="text-white"
      class="mr-15 laptop:mr-20 laptop-l:mr-0"
    />
  </div>
</template>


<script>
import UILanguageSwitcher from '@/components/UI-old/UILanguageSwitcher';


export default {
  components: {
    UILanguageSwitcher,
  },
};
</script>
